import { useEffect, useState } from 'react';
import { api, type HealthReport } from '../lib/api';

/**
 * The health endpoint is unauthenticated by design (a probe that needs a
 * session is useless to a monitor), so this badge is safe to render anywhere.
 */
export function HealthBadge(): JSX.Element {
  const [report, setReport] = useState<HealthReport | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    const poll = async (): Promise<void> => {
      try {
        const next = await api.health();
        if (live) {
          setReport(next);
          setFailed(false);
        }
      } catch {
        if (live) setFailed(true);
      }
    };
    void poll();
    const timer = window.setInterval(poll, 30_000);
    return () => {
      live = false;
      window.clearInterval(timer);
    };
  }, []);

  const status = failed ? 'unreachable' : report?.status ?? 'checking';
  const tone =
    status === 'ok' ? 'text-success' : status === 'degraded' ? 'text-warning' : status === 'checking' ? 'text-text-secondary' : 'text-danger';

  return (
    <span className={`micro-label ${tone}`} title={report ? `API ${report.version}` : undefined}>
      <span aria-hidden="true">●</span> API {status}
    </span>
  );
}
